import React, { useCallback, useMemo } from 'react';

import Select from '@repo/editor/src/components/SelectNew/Select';
import { P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { JsonFieldType } from '../schema';
import { InputLabel } from '../styles';

import { AiTextToolSelectProps } from './types';

const selectCustomStyles = {
  background: themeStyle.varInkSuperLight,
  borderRadius: '10px',
  textColorDisabled: themeStyle.varInkMedium,
};

const AiTextToolSelect: React.FC<AiTextToolSelectProps> = ({
  field,
  value: currentValue,
  onChange,
  disabled,
  error,
}) => {
  const { key, label, options, required } = field;
  const activeOption = useMemo(
    () => options.find(({ id }) => id === currentValue),
    [options, currentValue]
  );

  const handleInputChange = useCallback(
    (newValue: { id: string }) => {
      onChange<JsonFieldType.Select>(key, newValue.id);
    },
    [onChange, key]
  );

  return (
    <InputLabel key={key} disabled={disabled}>
      <P2>
        {label}
        {required && '*'}
      </P2>
      <Select
        activeOption={activeOption}
        customStyles={selectCustomStyles}
        disabled={disabled}
        error={error}
        options={options}
        onSelect={handleInputChange}
      />
    </InputLabel>
  );
};

export default AiTextToolSelect;
